import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconCheck from 'components/icons/iconCheck';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
const ProtectionPlanListItem = t0 => {
  const $ = _c(5);
  const {
    desc
  } = t0;
  let t1;
  if ($[0] !== desc) {
    t1 = desc.replace("<strong>", "").replace("</strong>", "");
    $[0] = desc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const descCleaned = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconCheck width="16" height="16" className="pr-[.2rem] mt-1 mr-2" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== descCleaned) {
    t3 = <li className="text-base flex pb-[.15rem] list-none">{t2}<SanitizedHtml className="text-left" html={descCleaned} /></li>;
    $[3] = descCleaned;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
ProtectionPlanListItem.propTypes = {
  desc: PropTypes.string
};
export default ProtectionPlanListItem;